import React, { useEffect, useState, useContext } from "react";
import { HashLink } from "react-router-hash-link";
import classNames from "classnames";

// Components
import Paragraph from "../../../../Atoms/Paragraph";
import { TrackingContext } from "../../../../Utils/TrackingWrapper";
import SubNavigationItemInfo from "./Components/SubNavigationItemInfo";

// Stylesheets
import styles from "./style.module.scss";

//Constants
import { SUB_NAVIGATION_ITEMS } from "./Constants/index";

export const TabletSubNavigation = ({ navState }) => {
  const [navigationInfo, setNavigationInfo] = useState({});
  const {
    trackingActions: { trackNavigation },
  } = useContext(TrackingContext);

  useEffect(() => {
    setNavigationInfo(SUB_NAVIGATION_ITEMS[0].menu[0].info);
  }, [navState]);

  const onHover = (menu) => {
    if (menu.info) {
      setNavigationInfo(menu.info);
    }
  };

  const onClickLink = (linkText) => {
    trackNavigation({
      clickURL: document.location.pathname,
      clickText: linkText,
      location: "main nav",
    });
  };

  return (
    <>
      <nav
        className={styles.tabletSubNavigation}
        id="j-tablet-sub-navigation-handle"
        aria-label="Subnavigation"
      >
        <div
          className={classNames(
            styles.tabletSubNavigation_container,
            "container"
          )}
        >
          <div className={styles.tabletSubNavigation_grid}>
            <ul
              className={classNames(
                styles.tabletSubNavigation_menu,
                styles.listReset
              )}
            >
              {SUB_NAVIGATION_ITEMS.map((item, index) => (
                <li key={index}>
                  <Paragraph
                    className={classNames(
                      styles.tabletSubNavigation_menuTitle,
                      "caption_primary"
                    )}
                  >
                    {item.title}
                  </Paragraph>
                  <ul
                    className={classNames(
                      styles.tabletSubNavigation_menuItems,
                      styles.listReset
                    )}
                  >
                    {item.menu.map((menuItem, index) => (
                      <li key={index} onMouseEnter={() => onHover(menuItem)}>
                        <HashLink
                          className={classNames(
                            styles.linkReset,
                            styles.tabletSubNavigation_menuItem,
                            menuItem.info === navigationInfo
                              ? styles.tabletSubNavigation_menuItemActive
                              : "",
                            menuItem.info
                              ? ""
                              : styles.tabletSubNavigation_menuItemNoInfo
                          )}
                          smooth
                          to={menuItem.url}
                          onClick={() => {
                            onClickLink(menuItem.title);
                          }}
                        >
                          <p>{menuItem.title}</p>
                        </HashLink>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
            <div className={styles.tabletSubNavigation_info}>
              <SubNavigationItemInfo
                info={navigationInfo}
              ></SubNavigationItemInfo>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default TabletSubNavigation;
